import { pick, dot } from 'dot-object'
import { Dependencies, FlatDependencies } from '.'
import {
  getValuePath,
  convertToDotted,
  getDependencyPaths,
  flattenDependencies
} from './path'
import { UrlParams } from 'utils/url/url.interface'

function resolveDependencies<T>(
  path: string,
  dependencyPath: string,
  state: T,
  dependencies: FlatDependencies<T>,
  currentPageInSession: string,
  urlParams: UrlParams
): boolean {
  const depFuncOrTree = dot(dependencies)[dependencyPath]

  if (!depFuncOrTree) {
    return true
  }

  const value = pick(getValuePath(path, dependencyPath), state)

  if (typeof depFuncOrTree === 'function') {
    return depFuncOrTree(state, value, currentPageInSession, urlParams)
  }
  return resolveDependencies(
    path,
    dependencyPath,
    value,
    depFuncOrTree,
    currentPageInSession,
    urlParams
  )
}

export function checkDependencies<T>(
  path: string,
  state: T,
  dependencies: Dependencies<T>,
  currentPageInSession: string,
  urlParams: UrlParams = {}
): boolean {
  const dottedPath = convertToDotted(path)
  const flatDependencies = flattenDependencies(dependencies)

  for (const depPath of getDependencyPaths(dottedPath)) {
    if (
      !resolveDependencies(
        dottedPath,
        depPath,
        state,
        flatDependencies,
        currentPageInSession,
        urlParams
      )
    ) {
      return false
    }
  }

  return true
}
